import { useLocale, useTranslations } from 'next-intl';

import Button from '@/components/button/Button';
import { ButtonStyle } from '@/components/button/ButtonStyle.enum';
import Modal, { ModalProps } from '@/components/Modal';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { getLocaleCode, getTranslationWithFallback } from '@cineamo/ui/src/helpers/translation-fallback-helper';

type NoOnlineTicketUrlModalProps = ModalProps & {
    domainConfiguration: DomainConfigurationDto;
};

export function NoOnlineTicketUrlModal(props: NoOnlineTicketUrlModalProps) {
    const t = useTranslations();
    const locale = useLocale();

    const emptyTicketLinkText = getTranslationWithFallback(
        props.domainConfiguration.websiteConfiguration?.emptyTicketLinkText || {},
        getLocaleCode(locale),
        t('program.no-online-ticketing-link.text')
    );

    return (
        <Modal
            {...props}
            onClose={null}
            title={t('program.no-online-ticketing-link.title')}>
            <div className="flex flex-col space-y-36 grow">
                <span className="whitespace-pre-wrap">{emptyTicketLinkText}</span>
                <div className="grow"></div>
                <Button
                    style={ButtonStyle.frameless_on_white_bg}
                    onClick={() => props.setModalIsOpen?.(false)}
                    css={{
                        color: props.domainConfiguration.style.onBackgroundColor
                    }}>
                    {t('common.ok')}
                </Button>
            </div>
        </Modal>
    );
}
